import { render, staticRenderFns } from "./NotificationModule.vue?vue&type=template&id=56a4b01b&scoped=true&"
import script from "./NotificationModule.vue?vue&type=script&lang=js&"
export * from "./NotificationModule.vue?vue&type=script&lang=js&"
import style0 from "./NotificationModule.vue?vue&type=style&index=0&id=56a4b01b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a4b01b",
  null
  
)

export default component.exports